export default {
  SALUDO: 'Bienvenido',
  'NOT FOUND': 'No encontramos la página que estas buscando',
  OWNER: 'Poder Judicial de Neuquén',
  DEPENDENCIA: 'Dirección general de Informática',
  PIE_PAGINA: 'Dirección general de Informática - Poder Judicial de Neuquén',
};
